<template>
  <div class="ar-page">
    <section class="ar-hero">
      <div class="ar-hero__blob ar-hero__blob--one" />
      <div class="ar-hero__blob ar-hero__blob--two" />
      <div class="ar-hero__content">
        <div class="ar-hero__icon">
          <feather-icon
            icon="UsersIcon"
            size="28"
          />
        </div>
        <div>
          <h2 class="ar-hero__title">
            Assign Personnel
          </h2>
          <p class="ar-hero__subtitle">
            Manage ISO application reviewers, certificate managers, follow-up department managers, and audit team.
          </p>
        </div>
      </div>
      <button
        type="button"
        class="ar-hero__refresh"
        :disabled="refreshing"
        @click="refreshActiveTab"
      >
        <feather-icon
          icon="RefreshCwIcon"
          size="16"
          :class="{ 'ar-spin': refreshing }"
        />
        Refresh
      </button>
    </section>

    <div class="ar-tabs">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        type="button"
        class="ar-tab"
        :class="[`ar-tab--${tab.key}`, { 'is-active': activeTab === tab.key }]"
        @click="selectTab(tab.key)"
      >
        <feather-icon
          :icon="tab.icon"
          size="16"
          class="ar-tab__icon"
        />
        <span class="ar-tab__label">{{ tab.label }}</span>
      </button>
    </div>

    <template v-for="tab in tabs">
      <component
        :is="tab.component"
        v-if="loadedTabs.includes(tab.key)"
        v-show="activeTab === tab.key"
        :key="tab.key"
        :ref="tab.key"
        :users-loading="usersLoading"
      />
    </template>
  </div>
</template>

<script>
import ASSIGN_PERSONAL_TABS from './tabs'

export default {
  name: 'AssignPersonal',
  data() {
    return {
      activeTab: ASSIGN_PERSONAL_TABS[0].key,
      loadedTabs: [ASSIGN_PERSONAL_TABS[0].key],
      tabs: ASSIGN_PERSONAL_TABS,
      usersLoading: false,
      refreshing: false,
    }
  },
  async mounted() {
    if (!this.$store.getters['generalData/assignList/assignListLoaded']) {
      this.usersLoading = true
      try {
        await this.$store.dispatch('generalData/assignList/fetchAssignList')
      } finally {
        this.usersLoading = false
      }
    }
  },
  methods: {
    selectTab(key) {
      if (!this.loadedTabs.includes(key)) {
        this.loadedTabs.push(key)
      }
      this.activeTab = key
    },
    getActivePanel() {
      const panelRef = this.$refs[this.activeTab]
      return Array.isArray(panelRef) ? panelRef[0] : panelRef
    },
    async refreshActiveTab() {
      const panel = this.getActivePanel()
      const refreshFn = panel?.fetchMembers || panel?.refresh
      if (!refreshFn) return

      this.refreshing = true
      try {
        await refreshFn.call(panel)
      } finally {
        this.refreshing = false
      }
    },
  },
}
</script>

<style lang="scss" src="../ApplicationReviewers.scss"></style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
